// import ecomBg from 'assets/img/illustrations/ecommerce-bg.png';
// import Background from 'components/common/Background';
import Flex from 'components/common/Flex';
import PropTypes from 'prop-types';
import React from 'react';
import { Card, ListGroup } from 'react-bootstrap';
import Notification from './Notification';

const GreetingCard = ({ type, location, dashboardMatrix }) => {
  return (
    <Card className="bg-transparent-50 overflow-hidden">
      <Card.Header className="position-relative">
        {/* <Background
          image={ecomBg}
          className="d-none d-md-block bg-card z-1"
          style={{
            backgroundSize: '230px',
            backgroundPosition: 'right bottom',
            zIndex: '-1'
          }}
        /> */}
        <div className="position-relative z-index-2">
          <div>
            <h3 className="text-primary mb-1">Good Afternoon, Admin!</h3>
            <p className="text-700">
              Here’s what happening with your location {location} today
            </p>
          </div>
          <Flex className="">
            {type === 'Shift' ? (
              <div className="">
                <p className="text-600 fs-10 fw-medium">Today's shifts</p>
                <h4 className="text-800 mb-0">{dashboardMatrix?.todayShift}</h4>
              </div>
            ) : (
              <div className="">
                <p className="text-600 fs-10 fw-medium">Today's visits</p>
                <h4 className="text-800 mb-0">{dashboardMatrix?.todayVisit}</h4>
              </div>
            )}
          </Flex>
        </div>
      </Card.Header>
      <Card.Body className="p-0">
        <ListGroup as="ul" className="mb-0 list-unstyled font-sans-serif">
          <Notification
            tab={type}
            notification={{
              title: `<strong>${dashboardMatrix?.noShowJobsActive} Missed</strong> you need to take a action`,
              linkFor: 'Missed-Action',
              type: 'danger'
            }}
            isLast={false}
          />
          <Notification
            tab={type}
            notification={{
              title: `<strong>${dashboardMatrix?.pendingJobsActive} Pending Clock Out</strong> you need to take a action`,
              linkFor: 'Pending Clock Out-Action',
              type: 'danger'
            }}
            isLast={false}
          />
          <Notification
            tab={type}
            notification={{
              title: `<strong>${dashboardMatrix?.pendingAssignment} Pending Assignment</strong> you need to take a action`,
              linkFor: 'Pending Assignment',
              type: 'primary'
            }}
            isLast={true}
          />
          <Notification
            tab={type}
            notification={{
              title: `<strong>${dashboardMatrix?.pendingReview} Pending Timecard</strong> you need to take a action`,
              linkFor: 'Pending Timecard',
              type: 'primary'
            }}
            isLast={true}
          />
        </ListGroup>
      </Card.Body>
    </Card>
  );
};

GreetingCard.propTypes = {
  type: PropTypes.any,
  dashboardMatrix: PropTypes.arrayOf(PropTypes.object),
  location: PropTypes.any
};

export default GreetingCard;
